import { ViteReactSSG } from "vite-react-ssg";
import type { RouteRecord } from "vite-react-ssg";
import "@/styles/tokens.css";
import { Layout } from "@/components/Layout";

// React Router v7's `lazy` spreads the returned object onto the route, so a bare
// `() => import("@/pages/Home")` would spread `{ default: Cmp }` and be ignored.
// Map default → Component instead.
const page = (load: () => Promise<{ default: React.ComponentType }>) => async () => {
  const { default: Component } = await load();
  return { Component };
};

export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, lazy: page(() => import("@/pages/Home")) },
      { path: "platform", lazy: page(() => import("@/pages/Platform")) },
      { path: "intelligence", lazy: page(() => import("@/pages/Intelligence")) },
      { path: "ai", lazy: page(() => import("@/pages/Ai")) },
      { path: "governance", lazy: page(() => import("@/pages/Governance")) },
      { path: "book-demo", lazy: page(() => import("@/pages/BookDemo")) },
    ],
  },
];

export const createRoot = ViteReactSSG({ routes });
